var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"#f0f0f0"},attrs:{"app":""}},[_c('app-layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }